import React, { useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import ServiceTypes from './ServiceTypes';
import ClientServices from './ClientServices';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`services-tabpanel-${index}`}
      aria-labelledby={`services-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function Services() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>Serviços</Typography>
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange}
          aria-label="services tabs"
        >
          <Tab label="Serviços dos Clientes" />
          <Tab label="Tipos de Serviço" />
        </Tabs>
      </Box>

      <TabPanel value={currentTab} index={0}>
        <ClientServices />
      </TabPanel>
      <TabPanel value={currentTab} index={1}>
        <ServiceTypes />
      </TabPanel>
    </Box>
  );
}

export default Services;
